import _times from "lodash/times";

import RatingStar from "@components/Icons/RatingStar";

const SellerReviewsStarRating = ({ reviewsCount = 1, reviewsRating = 0 }) => {
  return (
    <div className="relative inline-block">
      <div className="flex items-center">
        {/* Generate neutral rating stars */}
        {_times(5, (i) => (
          <RatingStar
            width="20px"
            height="20px"
            className="mr-1 text-gray-light"
            key={i}
          />
        ))}
      </div>
      <div
        className="absolute inline-block top-0 left-0 right-0 overflow-hidden"
        style={{
          width: `${
            reviewsRating / reviewsCount <= 5
              ? parseFloat(
                  (((reviewsRating / reviewsCount) * 100) / 5).toFixed(2)
                )
              : 0
          }%`,
        }}
      >
        <div className="flex items-center">
          <div className="flex items-center">
            {/* Generate filled rating stars */}
            {_times(5, (i) => (
              <RatingStar
                width="20px"
                height="20px"
                className="mr-1 fill-current flex-none text-yellow"
                key={i}
              />
            ))}
          </div>
        </div>
      </div>
    </div>
  );
};

export default SellerReviewsStarRating;
